import { FocusPanelViewData } from '../../models/focus-panel.models';
import { GetUserDto } from '../../models/view/employee';
import { ReducerAction } from '@keplerco/core';
import { AssessmentListItemResponse, AssessmentListResponse, AssessmentListSearchParams } from '../../overmind/actions';
import { ColumnConfiguration } from '../../models/column-configuration';

// state
interface AssessmentManagementState {
  searchParams: AssessmentListSearchParams;
  columnConfiguration: ColumnConfiguration[];

  data?: AssessmentListResponse;
  managingColumns?: boolean;
  isArchiveModalOpen?: boolean;
  isCloseModalOpen?: boolean;
  archiveSkillAssessmentData?: AssessmentListItemResponse;
  closeSkillAssessmentData?: AssessmentListItemResponse;
}

export const initialState: AssessmentManagementState = {
  searchParams: {
    companySlug: '',
    search: undefined,
    sortBy: undefined,
    pageSize: 15,
    page: 1,
  },
  columnConfiguration: [
    { label: 'Assessment Name', key: 'assessmentName', required: true },
    { label: 'Assessment Type', key: 'assessmentType', required: false, selected: true },
    { label: 'Date Created', key: 'dateCreated', required: false, selected: true },
    { label: 'Status', key: 'Status', required: false, selected: true },
  ],
};

// actions
export enum AssessmentManagementActionType {
  SetSearchParams,
  SetData,
  SetSkillAssessmentToManage,
  ManageColumns,
  EditColumnConfiguration,
  SetArchiveConfirmationModalOpen,
  SetCloseConfirmationModalOpen,
}

type AssessmentManagementAction =
  | ReducerAction<AssessmentManagementActionType.SetSearchParams, { payload: AssessmentListSearchParams }>
  | ReducerAction<AssessmentManagementActionType.SetData, { payload: AssessmentListResponse | undefined }>
  | ReducerAction<AssessmentManagementActionType.SetSkillAssessmentToManage, { payload: FocusPanelViewData<GetUserDto> }>
  | ReducerAction<AssessmentManagementActionType.EditColumnConfiguration, { payload: ColumnConfiguration[] }>
  | ReducerAction<AssessmentManagementActionType.ManageColumns, { payload: { open: boolean; reset?: boolean } }>
  | ReducerAction<AssessmentManagementActionType.SetArchiveConfirmationModalOpen, { payload: { open: boolean; data?: AssessmentListItemResponse } }>
  | ReducerAction<AssessmentManagementActionType.SetCloseConfirmationModalOpen, { payload: { open: boolean; data?: AssessmentListItemResponse } }>;

// reducer
export function reducer(state: AssessmentManagementState, action: AssessmentManagementAction): AssessmentManagementState {
  if (action.type === AssessmentManagementActionType.SetSearchParams) {
    return { ...state, searchParams: action.payload };
  }

  if (action.type === AssessmentManagementActionType.SetData) {
    return { ...state, data: action.payload };
  }

  if (action.type === AssessmentManagementActionType.ManageColumns) {
    if (!action.payload.reset) return { ...state, managingColumns: action.payload.open };
    else if (action.payload.reset) return { ...state, managingColumns: action.payload.open, columnConfiguration: [...initialState.columnConfiguration] };
  }

  if (action.type === AssessmentManagementActionType.EditColumnConfiguration) {
    return { ...state, columnConfiguration: action.payload };
  }

  if (action.type === AssessmentManagementActionType.SetArchiveConfirmationModalOpen) {
    return { ...state, isArchiveModalOpen: action.payload.open, archiveSkillAssessmentData: action.payload.data };
  }

  if (action.type === AssessmentManagementActionType.SetCloseConfirmationModalOpen) {
    return { ...state, isCloseModalOpen: action.payload.open, closeSkillAssessmentData: action.payload.data };
  }

  return state;
}

